import {Icon, Popover, Text} from '@albert-io/atomic';
import classNames from 'classnames';
import type {RefObject} from 'react';
import React from 'react';

import {useRerenderOnMount} from 'lib/hooks/useRerenderOnMount';

import './new-translation-toggle-tour.scss';

interface Props {
  onDismissTour: () => void;
  popoverPlacement?: 'bottom-end' | 'top-end' | 'top-start';
  translationToggleRef: RefObject<any>;
}

export default function NewTranslationToggleTour({
  onDismissTour,
  popoverPlacement = 'bottom-end',
  translationToggleRef
}: Props) {
  // Force a re-render the tick after the component mounts in case the ref is not set yet
  useRerenderOnMount();

  return (
    <Popover
      className={classNames(
        'new-translation-toggle-tour__popover',
        `new-translation-toggle-tour__popover--${popoverPlacement}`
      )}
      expanded
      optimizeForMobile={false}
      paddingLevel={0}
      // `popoverPlacement` doubles as a SCSS variant key (incl. 'bottom-end', which
      // Popover's `position` type omits); the value is forwarded to position as-is to
      // preserve existing runtime behavior.
      position={popoverPlacement as React.ComponentProps<typeof Popover>['position']}
      targetRef={translationToggleRef}
      usePortal={false}
      zLevel='low'
    >
      <div className='flex items-center gap-x1 content-primary-inverse-static'>
        <Text color='primary-inverse-static'>Translations have moved!</Text>
        {/* @ts-expect-error */}
        <Icon className='cursor-pointer' icon={['fal', 'times']} onClick={onDismissTour} />
      </div>
    </Popover>
  );
}
